import { supabase } from './supabase';

export function trimUsername(value) {
  return value.trim();
}

export async function getUserIdByUsername(username) {
  const p_username = trimUsername(username);
  if (!p_username) return null;

  const { data, error } = await supabase.rpc('get_user_id_by_username', { p_username });
  if (error) throw error;
  return data || null;
}

export async function getEmailByUsername(username) {
  const p_username = trimUsername(username);
  if (!p_username) return null;

  const { data, error } = await supabase.rpc('get_email_by_username', { p_username });
  if (error) throw error;
  return data || null;
}
